<template>
  <div>
    <div class="text-xs-right">
      <div>
        <v-btn outline color="primary" @click="showsearch = true"
          ><v-icon>search</v-icon>search</v-btn
        >
      </div>
      <v-btn :loading="exportloading" color="grey" outline @click="exportxlsx">
        <em class="fas fa-file-export" />
        &nbsp; Export&nbsp;
      </v-btn>
    </div>
    <v-pagination
      v-model="pageNumber"
      :total-visible="15"
      :length="pagelength"
      @input="changePage"
    ></v-pagination>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td>
            {{ props.item.pool_name }}
          </td>
          <td>
            {{ props.item.pool_code }}
          </td>
          <td>
            {{ props.item.ecoupon_prize_value | numberFormat }}
          </td>
          <td>
            {{ props.item.branch_name }}
          </td>
          <td>
            {{ props.item.is_used ? 'ใช้แล้ว' : 'ยังไม่ได้ใช้งาน' }}
          </td>
          <td>
            {{ props.item.first_name }}
          </td>
          <td>
            {{ props.item.timestamp ? formatdate(props.item.timestamp) : '-' }}
          </td>
          <td>
            {{ props.item.used_timestamp ? formatdate(props.item.used_timestamp) : '-' }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>ชื่อคูปอง</label>
                <input v-model="filter.ecoupon_name" class="form-control" type="text" /> </v-flex
              ><v-flex xs12 sm6 class="form-control pa-1">
                <label>มูลค่า</label>
                <input v-model="filter.ecoupon_prize_value" class="form-control" type="tel" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>รหัสคูปอง</label>
                <input v-model="filter.pool_code" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>ชื่อลูกค้า</label>
                <input v-model="filter.user_name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="pa-1">
                <label>{{ $t('สถานะ') }}</label>
                <v-select
                  v-model="filter.is_used"
                  :items="statusOption"
                  :label="$t('สถานะ')"
                  class="mr-2 px-0"
                  dense
                  solo
                  style="font-size: 14px"
                ></v-select>
                <!-- <input v-model="filter.is_used" class="form-control" type="text" /> -->
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>วันที่ได้รับ</label>
                <DatePickerWithoutButton v-model="filter.recrice_date">
                  <input
                    readonly
                    :value="formatdate(filter.recrice_date)"
                    class="form-control"
                    type="text"
                  />
                </DatePickerWithoutButton>
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>วันที่ใช้คูปอง</label>
                <DatePickerWithoutButton v-model="filter.used_date">
                  <input
                    readonly
                    :value="formatdate(filter.used_date)"
                    class="form-control"
                    type="text"
                  />
                </DatePickerWithoutButton>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
            <v-btn color="primary" @click="onsearch">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

const baseFilter = {
  ecoupon_name: '',
  ecoupon_prize_value: '',
  pool_code: '',
  user_name: '',
  is_used: '',
  recrice_date: '',
  used_date: ''
}

export default {
  components: {
    exportxlsx,
    DatePickerWithoutButton
  },
  data() {
    return {
      filter: { ...baseFilter },
      statusOption: [
        { text: 'ใช้แล้ว', value: true },
        { text: 'ยังไม่ได้ใช้งาน', value: false }
      ],
      showsearch: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      pagination: { rowsPerPage: -1 },
      items: [],
      exportloading: false,
      loading: false,
      headers: [
        { text: 'ชื่อคูปอง', sortable: false, value: 'pool_name' },
        { text: 'รหัสคูปอง', sortable: false, value: 'pool_code' },
        { text: 'มูลค่า', sortable: false, value: 'prize_value' },
        { text: 'สาขา', sortable: false, value: 'branch_name' },
        { text: 'สถานะ', sortable: false, value: 'is_used' },
        { text: 'ชื่อลูกค้า', sortable: false, value: 'first_name' },
        { text: 'วันที่กดรับ', sortable: false, value: 'timestamp' },
        { text: 'วันที่ใช้คูปอง', sortable: false, value: 'used_timestamp' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    },

    selectedCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    clearsearch() {
      this.filter = { ...baseFilter }
      this.getData()
      this.showsearch = false
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    async exportxlsx() {
      var params = {
        page_id: this.selectedBot.pageid,
        limit: this.total,
        offset: this.offset
      }
      this.exportloading = true
      const response = await toaMegapaintApi.getReceiveEcoupon(params)
      if (response.data && response.data.data) {
        const exporteddata = response.data.data
        const json = exporteddata.map((el) => {
          let status = 'ยังไม่ได้ใช้งาน'
          if (el.is_used) {
            status = 'ใช้แล้ว'
          }
          return {
            มูลค่า: el.ecoupon_prize_value,
            สาขา: el.branch_name,
            สถานะ: status,
            ชื่อลูกค้า: el.first_name,
            วันที่กดรับ: el.timestamp,
            วันที่ใช้คูปอง: el.used_timestamp
          }
        })

        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'exportecoupon' + '.xlsx')
        this.exportloading = false
      }
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    async getData() {
      var params = {
        page_id: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset,
        ...this.filter
      }
      this.loading = true

      try {
        const response = await toaMegapaintApi.getReceiveEcoupon(params)

        if (response.data && response.data.data && response.data.total) {
          this.items = response.data.data
          this.total = response.data.total
        } else {
          this.items = []
          this.total = 0
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    formatdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else return ''
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ToaMegaPaintReceiveEcouponList.vue